import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

export const useIsMobile = (bp: Breakpoint = 'sm'): boolean => useMediaQuery(useTheme().breakpoints.down(bp));
